import { createEmptyRows } from './helpers';
import type { SampleManagerAction, SampleManagerState } from './types';

// Re-export from helpers for backward compatibility
export { createEmptyRows };

/**
 * Reducer for managing SampleManager state
 */
export const sampleManagerReducer = (state: SampleManagerState, action: SampleManagerAction): SampleManagerState => {
  switch (action.type) {
    case 'UPLOAD_START':
      return {
        ...state,
        isProcessing: true,
        errorMessage: null,
      };

    case 'UPLOAD_SUCCESS':
      return {
        ...state,
        hasFileBeenUploaded: true,
        rowData: action.payload.rowData,
        errorMessage: null,
        isProcessing: false,
      };

    case 'UPLOAD_ERROR':
      return {
        ...state,
        hasFileBeenUploaded: false,
        errorMessage: action.payload.errorMessage,
        isProcessing: false,
      };

    case 'CLEAR_ERROR':
      return {
        ...state,
        errorMessage: null,
      };

    case 'UPDATE_ROW_COUNT':
      return {
        ...state,
        rowData: createEmptyRows(action.payload.count),
      };

    case 'RESIZE_ROWS': {
      const { count, existingRows } = action.payload;
      // Generate all rows with correct well positions and demux indices for the new count
      const allGeneratedRows = createEmptyRows(count);
      // Overlay existing user data onto the generated rows, preserving entered values
      const mergedRows = allGeneratedRows.map((generatedRow, i) => {
        if (i < existingRows.length) {
          // Preserve all user-editable fields (name, org_id, org_name, study_name), keep generated metadata
          const { name, org_id, org_name, study_name } = existingRows[i];
          return { ...generatedRow, name, org_id, org_name, study_name };
        }
        // New slot — use the generated row with correct position metadata
        return generatedRow;
      });
      return {
        ...state,
        rowData: mergedRows,
      };
    }

    case 'RESET':
      return {
        hasFileBeenUploaded: false,
        rowData: createEmptyRows(4),
        errorMessage: null,
        isProcessing: false,
      };

    default:
      return state;
  }
};
